var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 948,
    height: 900,
    viewBox: "0 0 948 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1327_1095",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 321,
    y: 212,
    width: 1553,
    height: 1553
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1645.95 439.649C1342.94 136.638 851.659 136.638 548.649 439.649C245.638 742.659 245.638 1233.94 548.649 1536.95C851.659 1839.96 1342.94 1839.96 1645.95 1536.95C1948.96 1233.94 1948.96 742.659 1645.95 439.649Z",
    fill: "url(#paint0_linear_1327_1095)",
    fillOpacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1462.74 622.855C1260.91 421.028 933.682 421.028 731.855 622.855C530.027 824.683 530.027 1151.91 731.855 1353.74C933.682 1555.56 1260.91 1555.56 1462.74 1353.74C1664.56 1151.91 1664.56 824.683 1462.74 622.855Z",
    fill: "url(#paint1_linear_1327_1095)",
    fillOpacity: 0.17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1288.3 799.242C1182.81 693.753 1011.78 693.753 906.291 799.242C800.803 904.73 800.803 1075.76 906.291 1181.25C1011.78 1286.74 1182.81 1286.74 1288.3 1181.25C1393.79 1075.76 1393.79 904.73 1288.3 799.242Z",
    fill: "url(#paint2_linear_1327_1095)",
    fillOpacity: 0.33
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1327_1095)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -492,
    y: 931.009,
    width: 1245,
    height: 1438,
    transform: "rotate(-90 -492 931.009)",
    fill: "#5D3DED"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1327_1095",
    x1: 548.649,
    y1: 1536.95,
    x2: 1645.95,
    y2: 439.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC615F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC615F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1327_1095",
    x1: 731.855,
    y1: 1353.74,
    x2: 1462.74,
    y2: 622.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC615F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC615F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1327_1095",
    x1: 906.291,
    y1: 1181.25,
    x2: 1288.3,
    y2: 799.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC615F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC615F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.819717bc9f94403ca2a85422b6fa47c8.svg";
export { ForwardRef as ReactComponent };